import { useMutation } from "react-query";

import { api } from "../utils";

import { useAuth } from "./useAuth";

interface ICreatePaymentMutationParameters {
    amount: string;
    returnUrl: string;
    description: string;
    orderId: string;
    test: boolean;
}

export const useCreatePayment = () => {
    const auth = useAuth();

    if (!auth.token) {
        throw new Error("Cannot create payment without authorization token.");
    }

    const {
        mutate,
        mutateAsync,
        isIdle,
        isLoading,
        data,
        error,
        isError,
        isSuccess,
    } = useMutation({
        mutationFn: async (
            parameters: ICreatePaymentMutationParameters,
        ): Promise<any> => {
            if (!auth.token) {
                throw new Error(
                    "Cannot create payment session without a valid token.",
                );
            }

            return await api.payments.createPayment({
                ...parameters,
                token: auth.token,
            });
        },
    });

    return {
        mutate,
        mutateAsync,
        isLoading,
        data,
        error,
        isIdle,
        isError,
        isSuccess,
    };
};
